/* eslint-disable no-unused-vars */
import React from 'react'
import {
    Typography,
} from '@mui/material';
import Activity from './Activity/Activity';
import TabTitle from '../../../pages/Member-Profile-Edit/TabTitle';
import InsightsPage from './Insights/InsightsPage';
import TimeSheetPage from './TimeSheet/TimeSheetPage';
import InvoicePage from './Invoice/InvoicePage';
import CalendarPage from './Calendar/CalendarPage';
import TimeOffPage from './TimeOff/TimeOffPage';
import MapPage from './Map/MapPage';
import JobPage from './JobSites/JobPage';
import PaymentPage from './Payments/PaymentPage';
import AchievementPage from './Achievement/AchievementPage';
import WorkBreakPage from './WorkBreaks/WorkBreakPage';
import OverTimePage from './OverTime/OverTimePage';
const labelStyle = {
    fontWeight: 500,
    mb: 0.5,
    color: '#1A1F36',
};

const inputStyle = {
    height: 46,
    fontSize: '14px',
};

const FeatureTabContent = ({ activeTab, menuItems }) => {
    switch (activeTab) {
        case 0:
            return (
                <>
                    <TabTitle title="ACTIVITY" />
                    <Activity />
                </>
            );

        case 1:
            return (
                <>

                    <TabTitle title="INSIGHTS" />
                    <InsightsPage />
                </>
            );

        case 2:
            return (
                <>
                    <TabTitle title="TIMESHEETS" />
                    <TimeSheetPage />
                </>
            );

        case 3:
            return (
                <>
                    <TabTitle title="INVOICES" />
                    <InvoicePage />

                </>
            );
        case 4:
            return (
                <>
                    <TabTitle title="CALENDAR" />
                    <CalendarPage />

                </>
            );
        case 5:
            return (
                <>
                    <TabTitle title="TIME OFF" />
                    <TimeOffPage />

                </>
            );
        case 6:
            return (
                <>
                    <TabTitle title="MAP" />
                    <MapPage />

                </>
            );
        case 7:
            return (
                <>
                    <TabTitle title="JOB SITES" />
                    <JobPage />

                </>
            );
        case 8:
            return (
                <>
                    <TabTitle title="PAYMENTS" />
                    <PaymentPage />

                </>
            );
        case 9:
            return (
                <>
                    <TabTitle title="ACHIEVEMENTS" />
                    <AchievementPage />

                </>
            );
        case 10:
            return (
                <>
                    <TabTitle title="WORK BREAKS" />
                    <WorkBreakPage />

                </>
            );
        case 11:
            return (
                <>
                    <TabTitle title="OVERTIME" />
                    <OverTimePage />

                </>
            );
        default:
            return (
                <Typography variant="body1" color="text.secondary">
                    <TabTitle title={menuItems[activeTab] || 'Details'} />
                </Typography>
            );
    }
};

export default FeatureTabContent